import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-no-teacher',
	templateUrl: './icon-no-teacher.component.svg',
})
export class IconNoTeacherComponent {}
